export default {"src":"/_next/static/media/relationships.f8d11bb6.svg","height":87,"width":87,"blurWidth":0,"blurHeight":0};